import {HOST} from "./config";

// Card content stores images as root-relative markdown paths (e.g. ![x](/ipa0.png))
// that are served by the backend, not the frontend origin — resolve them against HOST.
export const markdownComponents = {
    img: ({node, src, ...props}) => (
        <img src={src?.startsWith('/') ? HOST + src : src} {...props} alt={props.alt || ''}/>
    ),
};
